module.exports = __webpack_public_path__ + "static/media/IMG_8919.8499de6d.JPG";